  $(document).ready(function () {
    // Select the last li element's button and its child SVG
    var lastLiButton = $('nav li:last-child button');
    var lastLiButtonSVG = lastLiButton.find('svg');

    // Remove all existing click event listeners on the button
    lastLiButton.off('click');

    // Hide the SVG
    lastLiButtonSVG.hide(); // or lastLiButtonSVG.css('display', 'none');

    // Add a new click event listener for redirection
    lastLiButton.on('click', function () {
      // Replace 'your_destination_url' with the actual URL you want to redirect to
      window.location.href = 'https://rare-earth-oils.myshopify.com/pages/our-story';
    });
  });